<script setup>
import {computed} from 'vue'
import {useRouter} from 'vue-router'
import {useComponentsStore} from '@/stores/components'

const props = defineProps({
    item: Object,
    value: String
})

const router = useRouter()
const componentsStore = useComponentsStore()

const tableName = computed(() => {
    const component = componentsStore.items.find(o => o.id === props.item?.componentId)
    return component ? component.tableName : ''
})

const onClick = () => {
    if (tableName.value) {
        router.push({
            name: 'form',
            params: {
                component: tableName.value,
                id: props.item.itemId
            }
        })
    }
}
</script>

<template>
    <a href @click.prevent="onClick">{{ value }}</a>
</template>